import axios from 'axios';
import { TOKEN_KEY } from './auth';

// Set proper default values for API endpoints
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
const CARMAKES_ENDPOINT = '/car-makes';

// Debug configuration
console.log('CarMake API Configuration:');
console.log('API URL:', API_URL);
console.log('CARMAKES ENDPOINT:', CARMAKES_ENDPOINT);

// Create axios instance
const api = axios.create({
  baseURL: API_URL
});

// Add request interceptor to attach the token to all requests
api.interceptors.request.use(config => {
  console.log('API Request:', config.method, config.url);
  
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) {
    // Set the Authorization header with 'Bearer ' prefix
    config.headers.Authorization = `Bearer ${token}`;
    console.log('Token attached to request');
  } else {
    console.log('No token found in localStorage');
  }
  
  return config;
}, error => {
  console.error('Request interceptor error:', error);
  return Promise.reject(error);
});

// Get all car makes
export const getAllCarMakes = async (options = {}) => {
  console.log('Calling getAllCarMakes() with options:', options);
  const { all = true, activeOnly = false } = options;
  
  try {
    // Add query parameters to show all car makes
    const queryParams = new URLSearchParams();
    if (all) queryParams.append('all', 'true');
    if (activeOnly) queryParams.append('active', 'true');
    
    const queryString = queryParams.toString();
    const endpoint = queryString ? `${CARMAKES_ENDPOINT}?${queryString}` : CARMAKES_ENDPOINT;
    
    console.log('Fetching car makes from endpoint:', endpoint);
    const response = await api.get(endpoint);
    console.log('Car makes fetched:', response.data.length);
    return response.data;
  } catch (error) {
    console.error('Error fetching car makes:', error);
    throw error;
  }
};

// Get a single car make by id
export const getCarMake = async (id) => {
  console.log(`Calling getCarMake(${id})`);
  try {
    const response = await api.get(`${CARMAKES_ENDPOINT}/${id}`);
    console.log('Car make fetched:', response.data);
    return response.data;
  } catch (error) {
    console.error(`Error fetching car make with id ${id}:`, error);
    throw error;
  }
};

// Create a new car make (manager only)
export const createCarMake = async (carMakeData) => {
  console.log('Calling createCarMake() with data:', carMakeData);
  try {
    const response = await api.post(CARMAKES_ENDPOINT, carMakeData);
    console.log('Car make created:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error creating car make:', error);
    throw error;
  }
};

// Update a car make (manager only)
export const updateCarMake = async (id, carMakeData) => {
  console.log(`Calling updateCarMake(${id}) with data:`, carMakeData);
  try {
    const response = await api.put(`${CARMAKES_ENDPOINT}/${id}`, carMakeData);
    console.log('Car make updated:', response.data);
    return response.data;
  } catch (error) {
    console.error(`Error updating car make with id ${id}:`, error);
    throw error;
  }
};

// Delete a car make (manager only)
export const deleteCarMake = async (id) => {
  console.log(`Calling deleteCarMake(${id})`);
  try {
    const response = await api.delete(`${CARMAKES_ENDPOINT}/${id}`);
    console.log('Car make deleted:', response.data);
    return response.data;
  } catch (error) {
    console.error(`Error deleting car make with id ${id}:`, error);
    throw error;
  }
}; 